import React, { Component } from 'react';
import { localize } from 'linksoft';

import HeaderCell from '../common/header-cell';
import SearchInput from '../common/search-input';
import SearchCheckbox from './search-checkbox';
import ProfilePreview from './profile-preview/profile-preview';
import getPropertyValue from '../utils/property-extractor';
import contains from '../utils/contains';
import debounce from 'lodash/debounce';

const Resx = localize('App', 'Common');
const linksoftLink = (name, id) => window.linksoft.url[name]({ id: id });

class ValidatorTable extends Component {

    state = {
        filters: {},
        booleanFilters: {},
        previewProfileId: undefined,
    }

    setFilter = (filter, value) => {
        const filters = { ...this.state.filters };
        filters[filter] = value;
        this.setState({ filters: filters });
    }

    setBooleanFilter = (filter, value) => {
        const booleanFilters = { ...this.state.booleanFilters };
        booleanFilters[filter] = !value;
        this.setState({ booleanFilters: booleanFilters });
    }

    filterProfiles = (element) => {
        const { filters, booleanFilters } = this.state;
        let matched = true;
        for (let property in filters) {
            matched = matched && contains(getPropertyValue(element, property), filters[property]);
        }
        for (let bProperty in booleanFilters) {
            if (booleanFilters[bProperty]) {
                matched = matched && !!getPropertyValue(element, bProperty) === booleanFilters[bProperty];
            }
        }

        return matched;
    }

    handleConfirmButtonClicked = debounce(() => {
        const { confirmImport } = this.props;

        confirmImport();
    }, 400)

    toggleProfilePreviewHandler = profileId => {
        this.setState({previewProfileId: profileId});
    }

    render = () => {
        const { fileGuid, profiles, shouldImportChanged, openErrors, backUrl, profilePreviewUrl, canImport, isImporting } = this.props;

        return (
            <div className="validator-table">
                { this.state.previewProfileId 
                    && <ProfilePreview 
                            profilePreviewUrl={profilePreviewUrl}
                            fileGuid={fileGuid}
                            profileId={this.state.previewProfileId}
                            onClosePreview={this.toggleProfilePreviewHandler}>
                       </ProfilePreview>}
                <table className="table table-hover table-with-filter dataTable">
                    <thead className="header">
                        <tr>
                            <th><HeaderCell>{Resx.App.Import}</HeaderCell></th>
                            <th><HeaderCell>{Resx.Common.Id}</HeaderCell></th>
                            <th><HeaderCell>{Resx.App.Chapter}</HeaderCell></th>
                            <th><HeaderCell>{Resx.App.Profile}</HeaderCell></th>
                            <th><HeaderCell>{Resx.App.Axis}</HeaderCell></th>
                            <th><HeaderCell>{Resx.App.Status}</HeaderCell></th>
                        </tr>
                        <tr className="column-filters">
                            <th>
                                <SearchCheckbox onSearch={(checked) => this.setBooleanFilter('shouldImport', checked)}
                                    value={Resx.App.ToBeImported}>
                                </SearchCheckbox>
                            </th>
                            <th>
                                <SearchInput onSearch={(text) => this.setFilter('profileId', text)}></SearchInput>
                            </th>
                            <th>
                                <SearchInput onSearch={(text) => this.setFilter('chapter.name', text)}></SearchInput>
                            </th>
                            <th>
                                <SearchInput onSearch={(text) => this.setFilter('profile.name', text)}></SearchInput>
                            </th>
                            <th>
                                <SearchInput onSearch={(text) => this.setFilter('axis.name', text)}></SearchInput>
                            </th>
                            <th>
                                <SearchCheckbox
                                    onSearch={(checked) => this.setBooleanFilter('hasErrors', checked)}
                                    value={Resx.App.Status}>
                                </SearchCheckbox>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="body">
                        {
                            profiles
                            &&
                            profiles.filter(this.filterProfiles).map(p => (
                                <tr key={p.profileId}>
                                    <td>
                                        <input type="checkbox" disabled={p.hasErrors} checked={p.shouldImport} onChange={(e) => shouldImportChanged(p, e.target.checked)} />
                                    </td>
                                    <td>{p.profileId}</td>
                                    <td>
                                        <a href={linksoftLink('chapter', p.chapter.id)}>{p.chapter.name}</a>
                                    </td>
                                    <td className="profile-column">
                                        {!p.hasErrors
                                          && <a className="show-pointer show-profile-preview-button"
                                                onClick={() => this.toggleProfilePreviewHandler(p.profileId)}
                                                title={Resx.App.Charts}
                                                >
                                                    <i className="material-icons">assessment</i>
                                               </a>}
                                        <a href={linksoftLink('profile', p.profile.id)}>{p.profile.name}</a>
                                    </td>
                                    <td>
                                        <a href={linksoftLink('axis', p.axis.id)}>{p.axis.name}</a>
                                    </td>
                                    <td className={p.hasErrors ? 'has-error' : 'is-success'}>
                                        {
                                            p.hasErrors === true
                                                ? <a className="show-pointer error-button"
                                                    onClick={() => openErrors(p)}>
                                                    {Resx.App.FoundErrors + p.invalidLines.length}
                                                    &nbsp;<i className="material-icons">find_in_page</i>
                                                </a>
                                                : Resx.App.Successful
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                    <tfoot>
                    </tfoot>
                </table>
                <div className="panel-footer validation-buttons">
                    <button
                        onClick={this.handleConfirmButtonClicked}
                        disabled={canImport === false || isImporting}
                        className="btn btn-sm btn-success">
                        {Resx.App.ConfirmImport}
                    </button>
                    <a href={backUrl} className="btn btn-danger btn-sm btn-if">
                        {Resx.App.CancelImport}
                    </a>
                </div>
            </div>)
    }
}

export default ValidatorTable;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/validator-table/validator-table.js